export const PATHS = {
  HOME: '/',
  BUY: 'buy',
  RENT: 'rent',
  HOUSING: 'housing',
  REGIONS: 'regions',
  TERMS: 'terms',
  BLOG: 'blog',
  ABOUT: 'about',
  SERVICES: 'services',
  CALLBACK: 'callback',
  PROFILE: 'profile',
  SEARCH_PROFILE: 'search-profile',
  WATCH_LIST: 'watch-list',
  IMPRINT: 'imprint',
  EXTRA_CHARGES: 'extra-charges',
  PRIVACY: 'privacy',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  BROKERS: 'brokers',
  DIRECTLINK: 'directlink',
  DASHBOARD: 'dashboard',
  MEMBER_PROFILE: 'member-profile',
  REMAX_DEMO: 'remax-demo',
  PROJECT: 'project',
  PROJECTS: 'projects',
  WLAS_WIDGET: 'wlas-widget',
  CLAUDE_CONNECTOR: 'claude-connector',
  MASTER_ADMIN: 'master-admin',
} as const;
